import { render, staticRenderFns } from "./kaiYuans.vue?vue&type=template&id=6f8484fa&scoped=true"
import script from "./kaiYuans.vue?vue&type=script&lang=js"
export * from "./kaiYuans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8484fa",
  null
  
)

export default component.exports